
export const tentativeCall = (value, ...args) => {
  // `typeof(value) == 'function'` works for all known function detection cases.
  // `typeof(new Proxy(() => {}, {})) == 'function'` also works for proxies.
  return (typeof(value) == 'function') ? value(...args) : value;
};
